<template>
    <div>
        <div class="p-6 footer-privacy mt-5">
            <span class="bold">Safras & Mercado</span> {{$t('LOGIN').Footer_CMA}} <a href="#" class="forgot-pass cursor-pointer" @click.stop="$emit('open-privacy')">{{$t('HELP_PRIVACY_POLICY').Title}}</a> e <a href="#" class="forgot-pass cursor-pointer" @click.stop="$emit('open-terms')">{{$t('TERMS_USE').Title}}</a>.
            <div class="copyright mt-5" >
                <p>CMA – Consultoria, Métodos, Assessoria e Mercantil</p> COPYRIGHT @ {{ new Date().getFullYear() }}
            </div>
        </div>
        <flags class="auth-flags mt-3"></flags>
    </div>
</template>

<script>
import Flags from '../../components/translate/Flags.vue'
export default {
  components: { Flags },

}
</script>

<style>
.auth-flags {
    float: right;
}
</style>
